


import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import ProductPurchasesProductStock from "./ProductPurchasesProductStock";
import ProductSellingProductStock from "./ProductSellingProductStock";
// import UtilsFormule from "../../../utils/UtilsFormule";
const ProductDetailsSearchWarehouse = ({ listWarehouses }) => {

  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const { SearchBar } = Search;
  const [onGetStockProduct, setOnGetStockProduct] = useState(false);
  const [onGetStockProductVente, setOnGetStockProductVente] = useState(false);

  const [nameProductStock, setNameProductStock] = useState();
  const [productIdStock, setProductIdStock] = useState();
  const [warehouseIdStock, setWarehouseIdStock] = useState();

  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i className="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  // function dateFormatter(cell, row) {
  //   return <span>{UtilsFormule.formatDateHours(row.creationDate)}</span>;
  // }
  function buttonDeleteFormatter(cell, row) {
    return (
      <span>
        <button
          className="btn"
          onClick={(e) => {
            localStorage.setItem('idProduct', row.productId)
            localStorage.setItem('idWarehouse', row.warehouseId)
            sessionStorage.setItem("typeDocument", "Warehouse")
            window.open("/TransactionProductsDepot", "_blank");
          }}
        >
          <i class="fas fa-eye"></i>
        </button>
      </span>
    );
  }
  const columns = [
    {
      dataField: "warehouseName",
      text: "Dépôt",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "25%" };
      },
    }, {
      dataField: "warehouseType",
      text: "Type",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    }, {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },

    {
      dataField: "productId",
      text: "Prix d'achat",
      headerAlign: "center",
      align: "center",

      // headerStyle: () => {
      //   return { width: "12%" };
      // },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button
            style={{ width: 40 }}
            class="btn btn-sm "
            data-toggle="modal"
            data-target="#edit-brand"
          >
            <i className="fas fa-search" />
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", row);
          setProductIdStock(row.productId);
          setWarehouseIdStock(row.warehouseId);
          setNameProductStock(row.name);
          setOnGetStockProduct(true);
        },
      },
    },
    {
      dataField: "productId",
      text: "Prix de vente",
      headerAlign: "center",
      align: "center",

      // headerStyle: () => {
      //   return { width: "12%" };
      // },
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button
            style={{ width: 40 }}
            class="btn  btn-sm "
            data-toggle="modal"
            data-target="#edit-brand-vente"
          >
            <i className="fas fa-search" />
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", row);
          setProductIdStock(row.productId);
          setWarehouseIdStock(row.warehouseId);
          setNameProductStock(row.name);
          setOnGetStockProductVente(true);
        },
      },
    },
    {
      dataField: "productId",
      text: "Transaction",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
    }

  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }

  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div>
      {/* <div className="card-header">
        <h3 className="card-title">Les dépôts</h3>
      </div> */}
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={listWarehouses}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps}></MyExportCSV>
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>

      )}
      {onGetStockProduct && (
        <ProductPurchasesProductStock
          setOnGetStockProduct={setOnGetStockProduct}
          idProduct={productIdStock}
          nameProduct={nameProductStock}
          idWarehouse={warehouseIdStock}
        />
      )}

      {onGetStockProductVente && (
        <ProductSellingProductStock
          setOnGetStockProduct={setOnGetStockProductVente}
          idProduct={productIdStock}
          nameProduct={nameProductStock}
          idWarehouse={warehouseIdStock}
        />
      )}
    </div>
  );
};
export default ProductDetailsSearchWarehouse;